import type { FilteredFormValue } from '@trinnvis/dabih-api-client';
import type { FormElement } from '../../library/components/form';

export function filterFormStructure(structure: FormElement[], userUuid: string): FilteredFormValue[] {
  const result: FilteredFormValue[] = [];

  for (const el of structure) {
    // If there are values, filter and add one per element (empty string if no match)
    if ('values' in el) {
      const match = el.values.find((v) => v.userUuid === userUuid);
      result.push({ path: el.path, value: match ? match.value : '' });
    }

    // Always recurse into nested elements
    if ('elements' in el && el.elements) {
      result.push(...filterFormStructure(el.elements, userUuid));
    }
  }

  return result;
}
